<template>
	<div class="hero-image-component">
		<div class="hero-image-wrapper">
			<h1>“{{$t('homePage.testimonial')}}”</h1>
			<div class="image-container">
				<div class="image-wrapper">
					<img src="@/drc/assets/images/people/jo-debecker.webp" alt="hero-image">
				</div>
				<div class="hero-name">Jo Debecker</div>
				<div class="hero-title">{{$t('homePage.president')}}</div>
			</div>
			<div class="hero-image-animation">
				<img src="@/drc/assets/gifs/hero-image-animation.gif" alt="hero-image-animation">
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "HeroImage"
}
</script>

<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";

.hero-image-component {
	background: #002034;
	border-top: 1px solid #EBEBF52E;
	position: relative;
	overflow: hidden;
	padding-left: 6%;
	padding-right: 6%;

	@media (max-width: $tablet) {
		//padding-left: 0;
		//padding-right: 0;
		flex-direction: column;
		align-items: flex-start;
	}

	@media (max-width: $mobile) {
		padding-left: 15px;
		padding-right: 15px;
	}

	.hero-image-wrapper {
		display: flex;
		flex-direction: row;
		max-width: 1440px;
		justify-content: space-evenly;
		padding: 150px 0;
		align-items: center;
		margin: 0 auto;
		flex-wrap: wrap;
		min-height: 480px;

		@media (max-width: $tablet) {
			justify-content: flex-start;
			padding-top: 100px;
			padding-bottom: 100px;
		}

		@media (max-width: $mobile) {
			padding-bottom: 50px;
			padding-top: 20px;
		}

		h1 {
			font-family: Tiempos Text, serif;
			font-weight: 400;
			font-size: 34px;
			line-height: 41px;
			letter-spacing: 0.37px;
			vertical-align: middle;
			color: #FCFCFE;
			width: 100%;
			max-width: 888px;
			z-index: 1;
			//padding: 0 32px;

			//@media (max-width: $mobile) {
			//	padding-left: 15px;
			//	padding-right: 15px;
			//}
		}

		.image-container {
			display: flex;
			flex-direction: column;
			z-index: 1;

			@media (max-width: $tablet) {
				align-items: center;
				//margin-left: 32px;
			}

			.image-wrapper {

				@media (max-width: $tablet) {
					margin-top: 20px;
					padding-bottom: 50px;
				}

				@media (max-width: $mobile) {
					padding-top: 40px;
				}

				img {
					width: 132px;
					height: 132px;
					min-width: 132px;
					border-radius: 50%;
					object-fit: cover;
				}
			}

			.hero-name {
				font-family: Roboto, serif;
				font-weight: 700;
				font-size: 22px;
				line-height: 28px;
				letter-spacing: 0.35px;
				color: #FFB81C;
				text-align: center;
			}

			.hero-title {
				font-family: Roboto, serif;
				font-weight: 400;
				font-size: 15px;
				line-height: 20px;
				letter-spacing: 0;
				color: #FFF1D2;
				text-align: center;
			}
		}

		.hero-image-animation {
			position: absolute;
			left: 45%;
			top: 10%;
			height: 400px;
			z-index: 0;
			overflow: hidden;

			@media (max-width: 1200px) {
				left: 0;
				top: 0;
				overflow: hidden;
				right: -17%;
				height: 90%;
			}

			@media (max-width: $mobile) {
				right: -65%;
				top: unset;
				height: 360px;
				bottom: 100px;
			}

			img {
				max-width: 100%;
				max-height: 100%;
				object-fit: cover;

				@media (max-width: $tablet) {
					min-width: 100%;
					min-height: 100%;
				}

				@media (max-width: $mobile) {
					max-height: unset;
					min-height: unset;
					height: 360px;
				}
			}
		}
	}
}
</style>
